import { Spin } from "antd";

export default function NpsOverallScore({ data, tableData, isLoading }) {
  const score = Math.floor(
    (((data?.promoters_count ?? 0) - (data?.detractors_count ?? 0)) /
      (data?.total_replies ?? 1)) *
      100,
  );
  const npsTotalScore = isNaN(score) ? "N/A" : `${score}%`;
  const npsScores = (tableData ?? [])
    .map((item) => Math.floor(Number(item.totalScore)))
    .filter((score) => !isNaN(score) && score !== null && score !== undefined);

  const overallAverage =
    npsScores.length > 0
      ? Math.floor(
          npsScores.reduce((sum, score) => sum + score, 0) / npsScores.length,
        )
      : 0;

  const performanceData = [
    {
      label: "Total Responses",
      value: data?.total_replies ?? "N/A",
    },
    {
      label: "Net Promoter Score",
      value: data?.average_nps_percentage ?? "N/A",
    },
  ];

  const npsBreakdownData = [
    {
      label: "Promoters",
      value: data?.promoters_count ?? 0,
      style: { backgroundColor: "#9ecf5c" },
    },
    {
      label: "Neutrals",
      value: data?.passives_count ?? 0,
      style: { backgroundColor: "#f0af61" },
    },

    {
      label: "Detractor",
      value: data?.detractors_count ?? 0,
      style: { backgroundColor: "rgba(255, 255, 255,)" },
    },
  ];

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spin />
      </div>
    );
  }

  return (
    <>
      <div className="quesstore_performance_container">
        {performanceData.map((item, index) => (
          <div className="npsstore_performance_container_left" key={index}>
            <p className="nps_label">{item.label}</p>
            <p className="nps_value">{item.value}</p>
          </div>
        ))}
      </div>
      <div className="npsstore_performance_below_box">
        {npsBreakdownData.map((item, index) => (
          <div
            className="npsstore_performance_below_box_indi"
            key={index}
            style={item.style}
          >
            <span>{item.label}</span>
            <p>{item.value}</p>
          </div>
        ))}
      </div>
    </>
  );
}
